import { createCoreMethod } from '../../utils/createCoreMethod';
import { findNodeById } from '../../utils/findNodeById';
import { shallowFind } from '../../utils/shallowFind';

export const findFlowStartingPointNode = createCoreMethod(
  'findFlowStartingPointNode',
  async (
    startingPointId: string
  ): Promise<{ nodeId: string; parentNodeId: string } | null> => {
    let startingNode: BaseNode | null = shallowFind(startingPointId);

    if (!startingNode) {
      startingNode = findNodeById(startingPointId, figma.currentPage, 99);
    }

    if (!startingNode) return null;

    return new Promise((resolve) =>
      resolve({
        nodeId: startingNode?.id,
        parentNodeId: startingNode?.parent?.id || '',
      })
    );
  }
);
